import Reflux from 'reflux';

const NodesActions = Reflux.createActions({
  list: { asyncResult: true },
});

export default NodesActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/actions/nodes/NodesActions.js